RivalIQ.apps.Insights.module('widgets.media', function (media, App, Backbone, Marionette, $, _) {

    'use strict';

    const MAX_TOP_BOTTOM_POSTS_LIMIT = 9;
    const MIN_TOP_BOTTOM_POSTS_LIMIT = 3;

    const TopBottomLayout = RivalIQ.views.TopBottomLayout.mixin({
        onBeforeRenderLoaded: function () {
            const me = this;
            const orderBy = me.getOrderBy();
            me.dashboardModel.setProps({
                orderBy
            }, {
                silent: true
            });
        },

        getOrderBy: function () {
            const me = this;
            return App.utils.getOrderBy(me);
        },

        getBaseMetric: function (sortOrder) {
            const me = this;

            return App.utils.createInsightsMetric(me.getProp('objectType'), _.defaults({
                dimensions: [me.getProp('objectType')],
                sortOrder: sortOrder,
                property: me.getProp('objectType'),
                excludeNullPosts: true,
                limit: me.getGridLimit()
            }, me.getProps()));
        },

        getCountMetric: function () {
            const me = this;
            return App.utils.createInsightsMetric(me.getProp('objectType'), _.defaults({
                property: 'count',
                dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                objectType: me.getProp('objectType'),
                excludeNullPosts: true
            }, me.getProps()));
        },

        getGridLimit: function () {
            const me = this;
            if (me.dashboardModel.isExporting() && me.getProp('limit') <= MAX_TOP_BOTTOM_POSTS_LIMIT) {
                return me.getProp('limit');
            }
            return me.dashboardModel.isFocus() ? MAX_TOP_BOTTOM_POSTS_LIMIT : MIN_TOP_BOTTOM_POSTS_LIMIT;
        },

        loadData: function () {
            const me = this;

            const limit = me.getGridLimit();
            const topPostDefinition = new RivalIQ.models.MetricDefinition(me.getBaseMetric(1));
            const bottomPostDefinition = new RivalIQ.models.MetricDefinition(me.getBaseMetric(-1));
            const postCount = new RivalIQ.models.MetricDefinition(me.getCountMetric());
            const fetches = [
                topPostDefinition.fetch(),
                bottomPostDefinition.fetch(),
                postCount.fetch()
            ];

            return $.when.apply($, fetches)
                .then(function (topPostMetric, bottomPostMetric, postCount) {
                    // if we don't have enough posts to fill both grids show half or majority on top & half on bottom
                    // arbitrarily using the count of the topPostMetric. bottomPostMetric has the same count
                    const totalPostCount = postCount.getValue({
                        format: false
                    });
                    if (totalPostCount < (limit * 2)) {
                        me.displayLimit = Math.floor(totalPostCount / 2);
                    } else {
                        me.displayLimit = limit;
                    }

                    me.navigate = false;

                    const topMetricValues = topPostMetric.getValue({
                        format: false
                    });
                    const bottomMetricValues = bottomPostMetric.getValue({
                        format: false
                    });

                    // iteration order is not guaranteed if the keys can be parsed as integers
                    // https://stackoverflow.com/questions/5525795/does-javascript-guarantee-object-property-order/23202095#23202095
                    // since the ids being used are indeed integers, add an arbitrary string to ensure the id is read only as a string.
                    // in this case the id should come out for example as X.221617735
                    let topPostModels = _.map(topMetricValues, function (value) {
                        const model = _.last(value);
                        model.id = `X.${_.head(value)}`;
                        return model;
                    });
                    let bottomPostModels = _.map(bottomMetricValues, function (value) {
                        const model = _.last(value);
                        model.id = `X.${_.head(value)}`;
                        return model;
                    });

                    let orderBy = App.utils.getOrderBy(me);
                    if (orderBy === 'boosted_post_total_spend') {
                        orderBy = 'spend_amount';
                    }

                    const sortMetric = App.utils.createInsightsMetric(me.getProp('objectType'), {
                        property: orderBy,
                        source: me.getProp('source')
                    });
                    const sortFcn = new RivalIQ.models.MetricDefinition(sortMetric).getSortFunction();

                    topPostModels = topPostModels.sort(sortGridItem(1, orderBy, sortFcn));
                    bottomPostModels = bottomPostModels.sort(sortGridItem(-1, orderBy, sortFcn));

                    if (topPostMetric?.data?.dimensions) {
                        topPostMetric = _.cloneDeep(topPostMetric);
                        topPostMetric.data.dimensions[me.getProp('objectType')].buckets = _.keyBy(topPostModels, 'id');
                    }
                    if (bottomPostMetric?.data?.dimensions) {
                        bottomPostMetric = _.cloneDeep(bottomPostMetric);
                        bottomPostMetric.data.dimensions[me.getProp('objectType')].buckets = _.keyBy(bottomPostModels, 'id');
                    }

                    me.topPostMetric = topPostMetric;
                    me.bottomPostMetric = bottomPostMetric;
                    me.totalPostCount = totalPostCount;
                });
        }
    });

    function sortGridItem(sortOrder, orderByProperty, sortFcn) {
        return function (a, b) {
            let value = sortFcn(a[orderByProperty], b[orderByProperty], sortOrder);

            if (value === 0) {
                value = RivalIQ.utils.sort.default(new Date(a.published_at).valueOf(), new Date(b.published_at).valueOf(), sortOrder);
            }

            if (value === 0) {
                value = RivalIQ.utils.sort.default(a.id, b.id, sortOrder);
            }

            return value;
        };
    }

    media.MediaViewContainer = RivalIQ.views.SocialPostContainer.mixin({

        mixins: {
            brokenThumbnailHandler: RivalIQ.utils.BrokenThumbnailHandler
        },

        initialize: function () {
            const me = this;
            const existingTableLayout = me.getProp('tableLayout');
            if (existingTableLayout) {
                me.setProps('layout', existingTableLayout);
            }
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            let View = App.widgets.TableView;
            if (RivalIQ.apps.SocialPosts.utils.isGridLayout(me)) {
                View = App.widgets.media.InsightsGrid;
            } else if (RivalIQ.apps.SocialPosts.utils.isTopBottomLayout(me)) {
                View = TopBottomLayout;
                RivalIQ.postTags.utils.updateBodyClass(undefined, false);
            }

            me.container.show(new View(me.options));
        }
    });
});
